<div id="container-sideBar">
  <app-side-bar-profile></app-side-bar-profile>
  <router-outlet></router-outlet>
</div>


